import React, { PropTypes, Component, Fragment } from 'react'
import Modal from 'react-bootstrap/lib/Modal.js'
import styles from "./tarifas.css"
import Input from './Input.jsx'
import api from '../../apiClient/v1'
import { ModalTrigger } from '../../nominas/nominaIG/components/Modales.jsx'


export default class TarifaNomina extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }

        this.updateOperadorNomina = (operador) => {
            const nomina = {
                ...this.props.nomina,
                'captadorSEI': {
                    ...this.props.nomina.captadorSEI,
                    'dotacionTitular': this.props.nomina.captadorSEI.dotacionTitular.map((row) => row.id == operador.id ? operador : row)
                }
            }
            return nomina;
        }

        this.onChange = (e) => {
            const checked = e.target.checked;
            api.nomina(this.props.nomina.idNomina).changeTurnoAvanzada(checked)
                .then((response) => {
                    console.log(response)
                }).catch((error) => {
                    console.log(error)
                })
            const nomina = {
                ...this.props.nomina,
                "turno_avanzada": checked
            }
            this.context.updateNomina(nomina)
        }

        this.onChangeStatusOperador = (rowOperador, e) => {
            const row_op = {
                ...rowOperador,
                "turno_avanzada": e.target.checked
            }

            api.nomina(this.props.nomina.idNomina).changeTurnoAvanzadaOp({
                "operador_id": rowOperador.id,
                "turno_avanzada": e.target.checked
            }).then((response) => {
                console.log(response)
            }).catch((error) => {
                console.log(error)
            })
            const nomina = this.updateOperadorNomina(row_op);
            this.context.updateNomina(nomina)
        }

        this.onChangeHrsOperador = (rowOperador, e) => {
            const row_op = {
                ...rowOperador,
                "turno_avanzada_hrs": e.target.value
            }     
            api.nomina(this.props.nomina.idNomina).changeTurnoAvanzadaOpHrs({
                "operador_id": rowOperador.id,
                "turno_avanzada_hrs": e.target.value
            }).then((response) => {
                console.log(response)
            }).catch((error) => {
                console.log(error)
            })
            const nomina = this.updateOperadorNomina(row_op);
            this.context.updateNomina(nomina)
        }
    }
    render() {
        const checked = this.props.nomina.turno_avanzada
        const titulares = this.props.nomina.captadorSEI.dotacionTitular
        return (
            <div>
                <ModalTrigger>
                    {(isVisible, showModal, hideModal) =>
                        <div style={{
                            display: 'inline-block'
                        }}>
                            <button disabled={!checked} className="btn btn-success"
                                onClick={showModal}>Nomina Turno Avanzada
                            </button>
                            {isVisible && <ModalNomina
                                hideModal={hideModal}
                                titulares={titulares}
                                onChangeStatusOperador={this.onChangeStatusOperador.bind(this)}
                                onChangeHrsOperador={this.onChangeHrsOperador.bind(this)}
                            />}
                        </div>
                    }
                </ModalTrigger>

            </div>
        )
    }
}

TarifaNomina.contextTypes = {
    updateNomina: PropTypes.func
}

const ModalNomina = ({ hideModal, titulares, onChangeStatusOperador, onChangeHrsOperador }) => {
    return (
        <Modal show={true} onHide={hideModal} className={styles.zIndex}>
            <Modal.Header closeButton>
                <Modal.Title>Turno avanzada</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <table className={styles.text_xs + " table"}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Operador</th>
                                <th>Captador</th>
                                <th>Comuna</th>
                                <th>Turno</th>
                                <th>Hrs</th>
                            </tr>
                        </thead>
                        <tbody>
                            {titulares.map((operador, index) => {
                                return (
                                    <tr key={operador.id} className={index %2 == 0 ? styles.bgGray: ""}>
                                        <td>{index + 1}</td>
                                        <td>{operador.nombreCompleto}</td>
                                        <td>{operador.captador}</td>
                                        <td>{operador.comuna}</td>
                                        <td><input type='checkbox' checked={operador.turno_avanzada} onChange={(e) => onChangeStatusOperador(operador, e)} /></td>
                                        <td>
                                            <Input
                                                defaultValue={operador.turno_avanzada_hrs}
                                                onChange={(e) => onChangeHrsOperador(operador, e)} />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    )

}





// WEBPACK FOOTER //
// ./frontEnd/api/tarifa/TarifaNomina.jsx